import { Mappable } from './mappable';

export class SanctionedCountry extends Mappable {
  country_code: string;
  country_name: string;
  email_domain: string;

  constructor() { super() }
}
